import PropTypes from 'prop-types'
import { useState } from 'react'
import { Button } from 'react-bootstrap'
import Upload from '../../convertirTiendaOficial/Upload'

const ModalLogo = (props) => {
  const [show, setShow] = useState(false)
  const [logoPath, setLogoPath] = useState(false)
  const { tienda, setTienda } = props

  const handleModal = () => {
    setShow(!show)
  }

  const cerrarModal = () => {
    setTienda((prev) => ({
      ...prev,
      logoPath
    }))
    setLogoPath(true)
  }

  return (
    <>
      <Button
        data-target="logo"
        data-toggle="modal"
        variant="datos-perfil"
        onClick={() => {
          handleModal()
        }}
      >
        <span className="float-left">Logo</span>
        <span className="float-right">
          <i
            className={`fa ${
              tienda.logoPath !== null || logoPath === true
                ? 'fa-check f-ebm-green '
                : 'fa-times f-red '
            }`}
            aria-hidden="true"
          />
        </span>
      </Button>

      {show && (
        <div
          className="modal fade show d-block"
          role="dialog"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content" style={{ height: '90%' }}>
              <div className="modal-header">
                <h5 className="modal-title">
                  <b>Agregar Logo</b>
                </h5>
                <button type="button" className="close" onClick={() => setShow(false)}>
                  <span>x</span>
                </button>
              </div>
              <div className="modal-body">
                <Upload
                  esBanner={false}
                  accept={'image/*'}
                  idTiendaOficial={tienda.idTiendaOficial}
                  onCerrarModal={cerrarModal}
                />
                <p className="text-center mt-3">
                  La imagen tiene que tener un tamaño máximo de 140px x 140px.
                </p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShow(false)}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

ModalLogo.propTypes = {
  tienda: PropTypes.shape({
    logoPath: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idTiendaOficial: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  setTienda: PropTypes.func.isRequired
}

export default ModalLogo
